'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCurrentlyEditingState = exports.getCurrentlyEditingState = function getCurrentlyEditingState(state) {
    return state.getIn(['app', 'currentlyEditing']);
};

var isCurrentlyEditing = exports.isCurrentlyEditing = function isCurrentlyEditing(state) {
    return !!getCurrentlyEditingState(state).get('id');
};

var getCurrentlyEditingId = exports.getCurrentlyEditingId = function getCurrentlyEditingId(state) {
    return state.getIn(['app', 'currentlyEditing', 'id']);
};
var getCurrentlyEditingEditorKey = exports.getCurrentlyEditingEditorKey = function getCurrentlyEditingEditorKey(state) {
    return state.getIn(['app', 'currentlyEditing', 'editorKey']);
};

var getIsCurrentlyEditingThisElement = exports.getIsCurrentlyEditingThisElement = function getIsCurrentlyEditingThisElement(state, _ref) {
    var elementId = _ref.elementId,
        editorKey = _ref.editorKey;
    return getCurrentlyEditingId(state) === elementId && getCurrentlyEditingEditorKey(state) === editorKey;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/selection/currentlyEditingSelector.js
// module id = 233
// module chunks = 0